"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckFull = void 0;
const react_1 = __importDefault(require("react"));
const check_full_1 = __importDefault(require("../icons-path/check-full"));
const icons_svg_1 = require("../icons-svg");
require("../icons.types");
const CheckFull = (props) => {
    return react_1.default.createElement(icons_svg_1.IconsSvg, Object.assign({}, props, { path: check_full_1.default }));
};
exports.CheckFull = CheckFull;
